import { render, staticRenderFns } from "./TianjinTelecom1.vue?vue&type=template&id=35139b07&scoped=true"
import script from "./TianjinTelecom1.vue?vue&type=script&lang=js"
export * from "./TianjinTelecom1.vue?vue&type=script&lang=js"
import style0 from "./TianjinTelecom1.vue?vue&type=style&index=0&id=35139b07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35139b07",
  null
  
)

export default component.exports